import { ApiPaginatedResponse } from '@/interface/common.interface'

export const IMG_PLACE_HOLDER = require('./../assets/images/place-holder.jpg')

export const DEFAULT_ROUTE = {
  QSF_INSPECTION: '/qsf/inspection?page=1&group=ACTIVE',
  TASKS: '/tasks?search=&page_number=1&filter=all&list_view=all',
  PBF_ORDERS: '/pbf?filter=',
  PRODUCTS: '/products?page=1&search=&filter=',
}
export const VALIDATION_PATTERNS = {
  email: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
}

export const INSPECTION_TYPE_KEY = 'Inspection Type'

export const MODAL_CONTENT = {
  UPLOAD_FILE: 'Click to upload a file or drag and drop it here',
  UPLOAD_FILE_MAX: 'Excel, Word, PDF or Image (20MB max)',
}

export const PAGINATION = {
  page_number: 1,
  page_size: 10,
}

export const DEFAULT_API_PAGINATED_RESPONSE: ApiPaginatedResponse<any> = {
  data: [],
  pagination: {
    page_number: 0,
    page_size: 0,
    first_page: 0,
    last_page: 0,
    next_page: 0,
    total_page: 0,
    total_record: 0,
  },
}

export const MITT_EVENT_BUS = {
  INSPECTION_REPORT_COMMENT: 'on-report-comment',
}

export const SECTION_NAMES = {
  GENERAL_FABRIC_QUALITY_CHECK: 'generalFabricQualityCheck',
  SUMMARY_STATUS: 'summaryStatus',
  STRETCHABILITYCHECK: 'stretchabilityCheck',
  WASHTESTREPORT: 'washTestReport',
}

export const SUBSECTION_NAMES = {
  INSPECTED_ROLLS: 'inspectedRolls',
  SUMMARY_LOT: 'summaryLot',
  STRETCHABILITY: 'stretchability',
}

export const UPLOAD_DOCUMENTS_ENDPOINT = 'medias/multiple/documents'

export const MSG_FIELD_REQUIRED = 'This Fields required'
